import moment from 'moment'
import axios from 'axios'

// initial state
const state = {
  campaign: {},
  defaultService: 'regular',
  services: [],
  booking: {},
  form: {
    customerFirstName: '',
    customerLastName: '',
    customerEmail: '',
    customerMobile: '',
    customerPhone: '',
    alternateReturnPostcode: false,
    collectionPostcode: '',
    returnPostcode: '',
    returnAddress: '',
    collectionAddress: '',
    collectionWindow: 'ANY',
    marketingConsent: false,
    marketingConsentText: 'Want to get free maintenance tips, news about bike events, VIP offers and deals? We don’t share your data with anyone else.',
    collectionDate: null,
    returnDate: null,
    bikesForRepair: 1,
    bikes: [],
    service: {}
  }
}

// getters
const getters = {
  bookingForm: (state) => {
    return state.form
  },

  services: (state) => {
    return state.services
  },

  booking: (state) => {
    return state.booking
  },

  getDefaultService: (state) => {
    return state.defaultService
  },

  campaign: (state) => {
    return {
      'campaign_type': state.campaign.campaign_type,
      'campaign': state.campaign.campaign
    }
  },

  bookingFormToApi: (state) => {
    var base = {
      customer_first_name: state.form.customerFirstName,
      customer_last_name: state.form.customerLastName,
      customer_email: state.form.customerEmail,
      customer_mobile: state.form.customerMobile,
      customer_phone: state.form.customerPhone,
      collection_postcode: state.form.collectionPostcode,
      collection_address: state.form.collectionAddress,
      collection_date: moment(state.form.collectionDate).format('YYYY-MM-DD'),
      collection_time_window: state.form.collection_time_window,
      return_to_different_address: state.form.alternateReturnPostcode,
      return_postcode: state.form.returnPostcode,
      return_address: state.form.returnAddress,
      return_date: state.form.returnDate ? moment(state.form.returnDate).format('YYYY-MM-DD') : moment(state.form.collectionDate).add(1, 'day').format('YYYY-MM-DD'),
      return_time_window: 'ANY',
      bikes: state.form.bikes,
      marketing_email_consent_at: state.form.marketingConsent ? moment().format('YYYY-MM-DD hh:mm:ss') : null,
      marketing_email_consent_text: state.form.marketingConsentText,
      channel: 'CHANNEL_API_BOOKING'
    }

    if (state.campaign.campaign) {
      base.campaign_type = state.campaign.campaign_type
      base.campaign = state.campaign.campaign
    }

    return base
  },

  numberOfBikesForRepair: (state) => {
    return [...Array(state.form.bikesForRepair).keys()]
  },

  momentCollectionDate: (state) => {
    return moment(state.form.collectionDate || state.form.collection_date)
  },

  momentReturnDate: (state) => {
    return moment(state.form.returnDate)
  },

  formattedCollectionAddress: (state) => {
    return state.form.collectionAddress ? state.form.collectionAddress : state.booking.collection_address
  }
}

// actions
const actions = {
  updateBookingForm ({ commit, getters }, value) {
    value = {
      ...getters.bookingForm,
      ...value
    }
    commit('updateBookingForm', value)
  },

  getAddresses ({ commit, getters }, postcode) {
    return new Promise((resolve, reject) => {
      axios.get(`https://api.getaddress.io/find/${postcode}?api-key=TpZ3zSsHnEu8XkIMCJ0uqg22532&expand=true`)
        .then(data => {
          resolve(data.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  setupBikes ({ commit, getters }, options = {}) {
    options.sku = options.sku || getters.getDefaultService
    options.spend = options.spend || 20
    options.job_type = options.job_type || 'JOB_TYPE_C&R'
    getters.numberOfBikesForRepair.forEach(() => {
      commit('setupBike', options)
    })

    if (getters.bookingForm.bikes.length !== getters.numberOfBikesForRepair.length) {
      commit('trimBikesLength', getters.numberOfBikesForRepair.length)
    }
  }
}

// mutations
const mutations = {
  updateBookingForm (state, value) {
    state.form = value
  },

  updateBookingFormValue (state, keyValue) {
    state.form[keyValue.key] = keyValue.value
  },

  updateBookingFormBikeValue (state, keyValue) {
    state.form.bikes[keyValue.bikeKey][keyValue.key] = keyValue.value
  },

  setupBike (state, options) {
    state.form.bikes.push({
      model: '',
      type: 'TYPE_BROMPTON',
      asset_id: options.asset,
      job_type: options.job_type,
      is_electric: true,
      manafacturer: 'Brompton',
      colour: '',
      additional_authorised_spend: options.spend,
      customer_notes: '',
      service_sku: options.sku,
      unknown_details: false
    })
  },

  trimBikesLength (state, length) {
    state.form.bikes.length = length
  },

  setDefaultService (state, sku) {
    state.defaultService = sku
  },

  setServices (state, services) {
    state.services = [
      ...state.services,
      ...services
    ]
  },

  setCampaign (state, campaign) {
    state.campaign = campaign
  },

  setBooking (state, booking) {
    state.booking = booking
  },

  clearBookingForm (state) {
    state.booking = {}
    state.form = {
      customerFirstName: '',
      customerLastName: '',
      customerEmail: '',
      customerMobile: '',
      customerPhone: '',
      alternateReturnPostcode: false,
      collectionPostcode: '',
      returnPostcode: '',
      returnAddress: '',
      collectionAddress: '',
      collectionWindow: 'ANY',
      marketingConsent: false,
      marketingConsentText: 'Want to get free maintenance tips, news about bike events, VIP offers and deals?',
      collectionDate: moment().add(1, 'day').format('YYYY-MM-DD'),
      returnDate: (moment().add(3, 'day').weekday() && moment().add(3, 'day').weekday() !== 1) ? moment().add(3, 'day').format('YYYY-MM-DD') : moment().add(moment().add(4, 'day').weekday() === 1 ? 5 : 4, 'day').format('YYYY-MM-DD'),
      bikesForRepair: 1,
      bikes: [],
      service: {}
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
